import { ProfileSectionProps } from "./types";
import { FormSection } from "@/features/common/components/FormSection";
import { DataField } from "@/features/common/components/DataField";
import { VisaStatusFields } from "./VisaEntry/VisaStatusFields";
import { VisaDetailFields } from "./VisaEntry/VisaDetailFields";
import { VisaDocumentField } from "./VisaEntry/VisaDocumentField";

// Label mappings for display
const getVisaApplicationStatusLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    not_applied: "Nicht beantragt",
    applied: "Beantragt",
    granted: "Erhalten"
  };
  return labels[value] || value;
};

const getLaborMarketAuthStatusLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    not_required: "Nicht erforderlich",
    not_applied: "Nicht beantragt",
    applied: "Beantragt",
    granted: "Erteilt"
  };
  return labels[value] || value;
};

const getVisaStatusLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    fachkraft_anerkennung: "Fachkraft in Anerkennung (§16d AufenthG)",
    anerkannte_fachkraft: "Anerkannte Fachkraft (§18a / §18b AufenthG)",
    hilfskraft:
      "Hilfskraft während der Anerkennung (§19c Abs. 1 i.V.m. §6 BeschV)",
    ausbildung: "Berufsausbildung (§16a AufenthG)",
    sprachkurs: "Sprachkurs vor Ausbildung (§16g AufenthG)",
    eu_blue_card: "EU Blaue Karte",
    other: "Andere"
  };
  return labels[value] || value;
};

export function VisaEntrySection({
  profile,
  setProfile,
  readOnly,
  loading
}: ProfileSectionProps) {
  const visaApplicationStatus =
    profile?.visa_application_status || "not_applied";

  return (
    <FormSection title="Visum & Einreise">
      <div className="space-y-6">
        <VisaStatusFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
        />

        {(visaApplicationStatus === "applied" ||
          visaApplicationStatus === "granted") && (
          <VisaDetailFields
            profile={profile}
            setProfile={setProfile}
            readOnly={readOnly}
          />
        )}

        {visaApplicationStatus === "granted" && (
          <VisaDocumentField
            profile={profile}
            setProfile={setProfile}
            readOnly={readOnly}
            loading={loading}
          />
        )}
      </div>
    </FormSection>
  );
}

// View component
export function VisaEntryView({ profile }: { profile: any }) {
  return (
    <div className="space-y-1">
      <DataField
        label="Visum Status"
        value={
          profile.visa_application_status
            ? getVisaApplicationStatusLabel(profile.visa_application_status)
            : null
        }
      />
      <DataField
        label="Arbeitsmarktzulassung"
        value={
          profile.labor_market_authorization_status
            ? getLaborMarketAuthStatusLabel(
                profile.labor_market_authorization_status
              )
            : null
        }
      />
      <DataField
        label="Visum Typ"
        value={
          profile.visa_status ? getVisaStatusLabel(profile.visa_status) : null
        }
      />
      <DataField label="Einreisedatum" value={profile.visa_entry_date} />
      <DataField label="Visum gültig bis" value={profile.visa_valid_until} />
    </div>
  );
}
